import { updateCardLinkBehavior } from '../utils';

export default function cardWidget4(widgetID, widgetOptions, itemsVisible) {
  const widgetName = widgetID;
  const widgetOpts = widgetOptions;

  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    textOverImage: true,
    imageIsBackground: false,
    maxItemsVisible: itemsVisible,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.find('.card-content').remove();
        updateCardLinkBehavior({ items: data.items }, $widget.find('.card-widget-item'));
      } else {
        $widget.remove();
      }
    },
  });
}
